import React, { useState, useEffect } from 'react'
import RadioButton from 'components/form/RadioButton'
import { UseFormReturn } from 'react-hook-form'

interface Props {
  name: string
  form: UseFormReturn<any>
  elements: RadioButton[]
}

export default function RadioButtonGroup({ name, form, elements }: Props): JSX.Element {
  const [currentValue, setCurrentValue] = useState<string | null>(null)

  useEffect(() => {
    if (currentValue === null) {
      const value = elements.filter((el: RadioButton) => el.preSelected)[0]?.value
      setCurrentValue(value || null)
    }
  }, [elements, currentValue])

  const handleClick = (value: string) => {
    const shouldClear = currentValue === value
    if (shouldClear) {
      form.setValue(name, '')
      setCurrentValue('')
    } else {
      setCurrentValue(value)
    }
  }

  return (
    <>
      {elements.map((el: RadioButton, i: number) => (
        <RadioButton
          key={i}
          name={name}
          register={form.register}
          value={el.value}
          label={el.label}
          onClick={(e) => handleClick(e.target.value)}
        />
      ))}
    </>
  )
}
